import * as IF from "infrontjs";
import template from "./template.html";

/**
 * <top-menu> — the floating menu button in the top-right corner.
 *
 * It took the place the accommodation badge used to hold on the home screen,
 * and it took the job the fifth bottom tab used to do. Both moves are the same
 * decision: the drawer is reachable from every screen, so it belongs to the
 * shell rather than to one screen's header or to a tab slot that content could
 * use — and the corner opposite the thumb is where a phone puts the thing you
 * open occasionally rather than constantly.
 *
 * Hidden together with the tab bar, so full-bleed detail screens (which bring
 * their own back button in that corner's mirror) stay uncluttered.
 */
class TopMenu extends HTMLElement
{
    constructor()
    {
        super();
        this._connected = false;
    }

    connectedCallback()
    {
        if ( false === this._connected )
        {
            this.app = IF.App.get();
            this.render();
            this.bind();
            this._connected = true;
        }
    }

    render()
    {
        this.app.view.render( this, template, {} );
    }

    bind()
    {
        this.querySelector( '[data-id="open"]' )
            .addEventListener( "click", () => this.app.view.openMenu() );
    }

    /** Show/hide with the rest of the tab chrome (detail + auth screens hide it). */
    setHidden( hidden )
    {
        this.classList.toggle( "is-hidden", !!hidden );
    }
}

customElements.define( "top-menu", TopMenu );
